import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';
import { Field } from 'formik';
import * as yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faTimesCircle,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import Api from '../../api/Api';

const ConceptNameInput = ({ existingConcepts = [] }) => {
  const api = useRef(new Api());
  const validationSchema = yup
    .string()
    .required('Please provide a name for your design.')
    .min(3, 'Your design name should be at least 3 characters.')
    .max(30, 'Your design name cannot be more than 30 characters.')
    .matches(
      /^[A-Za-z0-9-_.()!@#$ ]+$/gm,
      'Design name may only contain letters, numbers, spaces, and some special characters: - _ @ # $ . ( )'
    )
    .test(
      'existingNameCheck',
      'A design with this name already exists.',
      (name) =>
        !existingConcepts
          .map((c) => c.name.toLowerCase().trim())
          .includes(name.toLowerCase().trim())
    )
    .test(
      'badWordCheck',
      'Please choose a more appropriate name.',
      async (name) =>
        !(await api.current
          .checkDesignName(name)
          .then((json) => {
            return json.isBad;
          })
          .catch((e) => console.error(e)))
    );
  const validateName = async (value) => {
    let result = await validationSchema
      .validate(value, {
        abortEarly: true,
      })
      .catch(function (err) {
        return err.errors[0];
      });
    return result === value
      ? null
      : {
          message: result,
          reset: 'Please choose a more appropriate name.' === result,
        };
  };

  return (
    <Field name="conceptName" validate={validateName}>
      {({ field, form }) => (
        <Form.Group controlId="formConceptName" className="mb-3">
          <Form.Label>Choose a name for your design:</Form.Label>
          <InputGroup>
            <Form.Control
              type="text"
              name="conceptName"
              placeholder="Enter a name for your design (max. 30 chars)"
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.errors.conceptName?.reset ? '' : field.value}
              isInvalid={form.errors['conceptName']}
            />
            <InputGroup.Text>
              {form.errors['conceptName'] ? (
                <FontAwesomeIcon icon={faTimesCircle} color="red" />
              ) : (
                <FontAwesomeIcon icon={faCheckCircle} color="green" />
              )}
            </InputGroup.Text>
          </InputGroup>
          {form.errors['conceptName'] && (
            <p>
              <b>Error:</b> {form.errors['conceptName'].message}
            </p>
          )}
        </Form.Group>
      )}
    </Field>
  );
};

ConceptNameInput.propTypes = {
  existingConcepts: PropTypes.array,
};
ConceptNameInput.defaultProps = {
  existingConcepts: [],
};

export default ConceptNameInput;
